var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showTableContent,
          expression: "showTableContent",
        },
      ],
      staticClass: "directory-order-table-components",
    },
    [
      !!_vm.items
        ? _c("div", { staticClass: "table-header-bar" }, [
            _c("div", { staticClass: "header-left-block float-left" }, [
              _c("label", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.titleMap[_vm.viewType])),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "last-update__text" }, [
                _vm._v(_vm._s(_vm.lastUpdated)),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "header-right-block float-right" },
              [
                _c("DropdownMenu", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isFloor,
                      expression: "!isFloor",
                    },
                  ],
                  attrs: {
                    options: _vm.screenList,
                    format: function (item, length) {
                      return "Screen " + item + " of " + length
                    },
                    selected: _vm.currentScreen,
                    afterSelect: function (val) {
                      return (_vm.currentScreen = val)
                    },
                    withAll: true,
                  },
                }),
                _vm._v(" "),
                _c("DropdownMenu", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isFloor,
                      expression: "!isFloor",
                    },
                  ],
                  attrs: {
                    options: _vm.displayList,
                    format: function (item, length) {
                      return "Column " + item + " of " + length
                    },
                    selected: _vm.currentColumn,
                    afterSelect: function (val) {
                      return (_vm.currentColumn = val)
                    },
                    withAll: true,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "directory-table-content" }, [
        _c(
          "table",
          { staticClass: "directory-order-table" },
          [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", { staticClass: "tenancyId" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("directory.label.tenancyRecordId")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isFloor
                    ? _c("th", { staticClass: "premises" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("directory.label.premises")) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.headers, function (header) {
                    return _c("th", { key: header.attr, class: header.cls }, [
                      _vm._v(
                        "\n            " + _vm._s(header.title) + "\n          "
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("th", { staticClass: "effective-date" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("directory.label.effectiveDate")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.isFloor
                    ? _c("th", { staticClass: "screen" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("directory.label.screen")) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", { staticClass: "display" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.isFloor
                            ? _vm.$t("directory.label.display")
                            : _vm.$t("directory.label.column")
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "onHold" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("directory.label.onHold")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "status" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("directory.label.status")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "order" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("directory.label.order")) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "action" }),
                  _vm._v(" "),
                  _c("th", { staticClass: "action" }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.displayTableRows, function (row, index) {
              return _c("DirectoryOrderTableRow", {
                key: row.item.id,
                attrs: {
                  viewType: _vm.viewType,
                  directory: row.item,
                  displayItems: row.displayItems,
                  orderOptions: row.orderOptions,
                  index: index,
                  actionSettings: row.actionSettings,
                  disableAllExceptLinks: false,
                  windowScrollY: _vm.windowScrollY,
                },
              })
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "ActionConfirmModal",
        {
          ref: "removePublishedConfirmModal",
          attrs: {
            confirmTitle: _vm.$t("directory.msg.removePublishedConfirm.title"),
          },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c(
              "div",
              { staticClass: "confirm-remove-table" },
              [
                _c("CommonTable", {
                  ref: "removePublishedConfirmModal",
                  attrs: {
                    needCache: false,
                    tableContentLists: _vm.currentRemoveDirectory,
                    renderHeaderList: _vm.confirmRemoveTableHeader,
                    resizeColumnWhenContentChange: false,
                    defaultOrder: false,
                    needFilter: false,
                    tableId: "confirm-remove-table",
                    minWidth1800px: false,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-pure-text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("directory.msg.removePublishedConfirm.message")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }